// extracted by mini-css-extract-plugin
module.exports = {"preheading":"SectionHeading_preheading__zbRXW","heading":"SectionHeading_heading__qvQem","headings":"SectionHeading_headings__elHOS"};